export default __webpack_public_path__ + "static/media/LandscapeSelect.574b5735.svg";